interface SupportTimeLogBillingTicket {
    offerNumber?: string;
    offerTypeDefault?: boolean;
    projectBillable?: boolean;
    projectInvoice?: boolean;
    project?: unknown;
}

interface SupportTimeLogBillingUser {
    supportTimeLogsAlwaysNonBillable?: boolean;
}

export const defaultNewTimeLogBilling = (
    ticket?: SupportTimeLogBillingTicket,
    user?: SupportTimeLogBillingUser,
) => {
    const project = ticket?.project;
    const projectBilling = typeof project === "object" && project !== null
        ? project as {billable?: boolean; invoice?: boolean}
        : undefined;
    const nonBillable = user?.supportTimeLogsAlwaysNonBillable ||
        ticket?.offerTypeDefault ||
        !!ticket?.offerNumber?.trim();
    return {
        billable: !nonBillable && (ticket?.projectBillable ?? projectBilling?.billable) !== false,
        invoice: !nonBillable && (ticket?.projectInvoice ?? projectBilling?.invoice) !== false,
    };
};

export const defaultNewTimeLogInvoice = (
    ticket?: SupportTimeLogBillingTicket,
    user?: SupportTimeLogBillingUser,
) => defaultNewTimeLogBilling(ticket, user).invoice;
